import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RacingGameCoreService } from './racing-game-core.service';
import { RacingGameSelectorComponent } from './racing-game-selector/racing-game-selector.component';

@NgModule({
  declarations: [RacingGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [RacingGameCoreService],
  exports: [RacingGameSelectorComponent],
})
export class RacingGameCoreModule {}
